import React from "react";
import MuiCard from "@mui/material/Card";
import MuiCardContent from "@mui/material/CardContent";

const Card = ({ children, sx = {}, ...props }) => (
  <MuiCard sx={sx} {...props}>
    <MuiCardContent>
      {children}
    </MuiCardContent>
  </MuiCard>
);

export default Card;
